import React, { Component } from "react";
import ReactDOM from "react-dom";
import QR from "qrcode.react";
import { I18n } from "react-redux-i18n";

import "../../../styles/components/utils/components/ChargerQR.scss";

class ChargerQR extends Component {
  constructor(props) {
    super(props);
    this.svgRef = null;
    this.firstRender = true;
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.firstRender ||
      prevProps?.template !== this.props.template ||
      prevProps?.qrCodeId !== this.props.qrCodeId
    )
      this.replaceQRCode();
  }

  replaceQRCode() {
    this.firstRender = false;
    if (this.props.template && this.svgRef !== null) {
      // 1. decode SVG from base64
      let decodedSVG = null;
      try {
        decodedSVG = atob(this.props.template);
      } catch (err) {
        this.props.setAlert(I18n.t(err.response.data.message), "danger");
      }
      if (decodedSVG === null) return;

      // 2. find placeholder elements
      this.svgRef.innerHTML = decodedSVG.trim();
      this.svgRef.firstElementChild.setAttribute("width", "100%");
      this.svgRef.firstElementChild.setAttribute("height", "100%");

      const qrCodeEl = this.svgRef.querySelector("#QRCode");
      const textEl = this.svgRef.querySelector("#ID > g > text");
      if (qrCodeEl === null || textEl === null) {
        console.error("Invalid SVG template. Aborting QR code generation...");
        return;
      }

      // 3. replace placeholders with real counterparts
      const qrCodeBBox = qrCodeEl.getBBox();
      const textElBBox = textEl.getBBox();

      textEl.textContent = `ID: ${this.props.qrCodeId}`;
      textEl.setAttribute(
        "transform",
        `translate(${qrCodeBBox.x + textElBBox.width / 2} ${
          textEl.transform.baseVal[0].matrix.f
        })`
      );
      const group = document.createElementNS("http://www.w3.org/2000/svg", "g");
      ReactDOM.render(
        <QR
          value={`https://link.go-evio.com/qrcode?id=${this.props.qrCodeId}`}
          size={qrCodeBBox.width}
          x={qrCodeBBox.x}
          y={qrCodeBBox.y}
          level="H"
          bgColor="transparent"
          fgColor="#353841"
          renderAs="svg"
        />,
        group
      );

      qrCodeEl.replaceWith(group);
    }
  }

  render() {
    return (
      <div id="chargerQR">
        <svg
          ref={(ref) => (this.svgRef = ref)}
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          style={{ isolation: "isolate", backgroundColor: "transparent" }}
          viewBox="0 0 340.157 188.976"
          width={
            this.props.style && this.props.style.width
              ? `${this.props.style.width}px`
              : "340.157pt"
          }
          height={
            this.props.style && this.props.style.height
              ? `${this.props.style.height}px`
              : "188.976pt"
          }
        ></svg>
      </div>
    );
  }
}

export default ChargerQR;
